import type { Auditor } from '@/generated/graphql';

import { IUser, mapGQLUser } from './user';

export interface IAuditor {
  id: string;
  firstName: string;
  lastName: string;
  contactNumber: string;
  createdAt: string;
  updatedAt: string;

  user: IUser;
}

export interface IAuditorTable {
  id: string;
  firstName: string;
  lastName: string;
  name: string;
  username: string;
  contactNumber: string;
  createdAt: string;
}

export interface IAuditorQueryVariable {
  first: number;
  after?: string;
  before?: string;
}

export function mapGQLAuditor(gql_Auditor?: Auditor | null): IAuditor {
  return {
    id: gql_Auditor?.id ?? '',
    firstName: gql_Auditor ? gql_Auditor.firstName ?? '' : '',
    lastName: gql_Auditor ? gql_Auditor.lastName ?? '' : '',
    contactNumber: gql_Auditor ? gql_Auditor.contactNumber ?? '' : '',

    updatedAt: gql_Auditor ? gql_Auditor.updatedAt ?? new Date().toISOString() : new Date().toISOString(),
    user: mapGQLUser(gql_Auditor?.user),
    createdAt: gql_Auditor
      ? new Date(gql_Auditor.createdAt).toLocaleString('en-US', {
          timeZone: 'Asia/Manila',
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour12: true,
          minute: '2-digit',
          hour: '2-digit',
        }) ?? ''
      : '',
  };
}

export interface IManagerAuditorCashInput {
  amount: string;
  AuditorId: string;
  type: 'transfer' | 'withdrawal';
}

export interface IManagerAuditorsChipsInput {
  amount: string;
  type: 'transfer' | 'withdrawal';
}

export interface IEditAuditorInput {
  firstName: string;
  lastName: string;
  contactNumber: string;
  username: string;
}

export interface IUpdateAuditorPassword {
  newPassword: string;
  confirmPassword: string;
}

export interface IAddAuditorInput {
  firstName: string;
  lastName: string;
  email: string;
  username: string;
  password: string;
  contactNumber: string;
}
